<div
  id="{{ createAttributeIdForConfigurator(attribute) }}"
  *ngIf="attribute?.values?.length"
>
  <div *ngIf="withQuantity" class="cx-attribute-level-quantity-price">
    <cx-configurator-attribute-quantity
      (changeQuantity)="onChangeQuantity($event)"
      [quantityOptions]="extractQuantityParameters()"
    ></cx-configurator-attribute-quantity>

    <cx-configurator-price
      [formula]="extractPriceFormulaParameters()"
    ></cx-configurator-price>
  </div>

  <cx-configurator-attribute-product-card
    [id]="createAttributeValueIdForConfigurator(attribute, value?.valueCode)"
    (handleDeselect)="onSelect('')"
    (handleSelect)="onSelect($event)"
    *ngFor="let value of attribute?.values"
    [productCardOptions]="extractProductCardParameters(value)"
  >
  </cx-configurator-attribute-product-card>
</div>
